import React, { useCallback } from 'react';
import { cn } from '@express-labs/raven-tools';
import s from './AccessibilityLink.scss';
import { Link, LinkProps } from '@express-labs/raven-ui';

export interface AccessibilityProps extends LinkProps<'a'> {
  className?: string;
  hideAccessibilityLink?: boolean;
}

export const AccessibilityLink = ({
  className,
  hideAccessibilityLink = false,
  theme = 'light',
}: AccessibilityProps) => {
  if (hideAccessibilityLink) {
    return null;
  }

  const handleOnclick = useCallback(() => {
    window.enableUsableNetAssistive?.();
  }, []);

  return (
    <Link
      className={cn(
        'unAssistiveView UsableNetAssistive',
        s.enableAccessibility,
        className
      )}
      title="By activating this link you will enable accessibility for all the data and features of the site"
      onClick={handleOnclick}
      id="action_insert_15550063624141143"
      as="a"
      theme={theme}
      tabIndex={1}
    >
      Enable Accessibility
    </Link>
  );
};
